import { Button } from "@src/appV2/redesign/components/Button";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  Text,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

import { DialogFooter } from "../../components/DialogFooter";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";

interface VisitConfirmedBottomSheetProps {
  modalState: UseModalState;
  visitDate: Date;
}

export function VisitConfirmedBottomSheet(props: VisitConfirmedBottomSheetProps) {
  const { modalState, visitDate } = props;
  const { patient } = useInHomeVisitModalsDataContext();
  const { attributes: patientAttributes } = patient ?? {};
  const { externalPatientIdentifier } = patientAttributes ?? {};

  const formattedDate = visitDate.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  });

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth variant="contained" onClick={modalState.closeModal}>
            Got it
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="shift-booked"
        title="Your visit is confirmed"
        description={
          <Text variant="body1">
            Your visit for {externalPatientIdentifier} is confirmed for {formattedDate}
          </Text>
        }
      />
    </BottomSheet>
  );
}
